// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__bP7Ht","label":"Chip_label__nTXjr","primary":"Chip_primary__unuzd","tertiary":"Chip_tertiary__NmvpE","remove":"Chip_remove__z8CIP"};